<template>
  <div class="nettdoc-status-nav">
    <img
      @click="exit"
      class="nettdoc-status-nav__close"
      src="../assets/icon-basis-ic-close.svg"
      alt="close"
    />
    <div v-if="step <= 5" class="nettdoc-status-nav__progress-wrapper">
      <img
        class="nettdoc-status-nav__progress"
        :src="require('../assets/control-processor-'+step+'.svg')"
        :alt="'progress step number'+step"
      />
      <div class="nettdoc-status-nav__clickable-grid">
        <div></div>
        <div
          class="nettdoc-status-nav__clickable-grid--button"
          @click="$route.path !== `/${$i18n.locale}/nettdoctor/basicinformation` ? $router.push(`/${$i18n.locale}/nettdoctor/basicinformation`) : null"
        ></div>
        <div></div>
        <div
          class="nettdoc-status-nav__clickable-grid--button"
          @click="$route.path !== `/${$i18n.locale}/nettdoctor/symptoms` ? $router.push(`/${$i18n.locale}/nettdoctor/symptoms`) : null"
        ></div>
        <div></div>
        <div
          class="nettdoc-status-nav__clickable-grid--button"
          @click="$route.path !== `/${$i18n.locale}/nettdoctor/symptomdetails` ? $router.push(`/${$i18n.locale}/nettdoctor/symptomdetails`) : null"
        ></div>
        <div></div>
        <div
          class="nettdoc-status-nav__clickable-grid--button"
          @click="$route.path !== `/${$i18n.locale}/nettdoctor/patientinformation` ? $router.push(`/${$i18n.locale}/nettdoctor/patientinformation`) : null"
        ></div>
        <div></div>
        <div
          class="nettdoc-status-nav__clickable-grid--button"
          @click="$route.path !== `/${$i18n.locale}/nettdoctor/medicalhistory` ? $router.push(`/${$i18n.locale}/nettdoctor/medicalhistory`) : null"
        ></div>
        <div></div>
      </div>
    </div>
    <span
      v-if="step === 6"
      class="nettdoc-status-nav__save"
      @click="$router.push(`/${$i18n.locale}/nettdoctor/saveandexport`)"
    >{{$t('Save and Export')}}</span>

    <template v-if="showExitModal">
      <div class="nettdoc-exit-modal">
        <div class="nettdoc-exit-modal__container">
          <h2 class="nettdoc-header">{{$t('Exit the sheets')}}</h2>
          <p>{{$t('All the information you entered will be deleted completly after you exit the sheets.')}}</p>
          <p>{{$t('Are you sure you want to exit?')}}</p>
          <div class="nettdoc-exit-modal__container--bottom">
            <span @click="exitAndDelete">{{$t('Exit & Delete')}}</span>
            <span @click="abortExit">{{$t('Cancel')}}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";
export default observer({
  name: 'StatusNav',
  data() {
    return {
      store: store,
      showExitModal: false
    }
  },
  props: {
    step: Number
  },
  methods: {
    exit: function() {
      this.showExitModal = true
    },
    abortExit: function() {
      this.showExitModal = false
    },
    exitAndDelete: function() {
      localStorage.clear()
      this.store.reset()
      this.$router.push(`/${this.$i18n.locale}/nettdoctor`)
    }
  }
})
</script>

<style lang="scss" scoped>
.nettdoc-status-nav {
  padding: 16px;
  display: grid;
  grid-template-columns: 40px auto;
  &__close {
    cursor: pointer;
    float: left;
  }
  &__progress {
    float: right;
    width: 100%;
    align-self: center;
  }
  &__save {
    cursor: pointer;
    text-transform: uppercase;
    float: right;
    text-align: right;
    align-self: center;
    font-size: 16px;
    font-weight: bold;
  }
  &__progress-wrapper {
    position: relative;
    display: grid;
  }
  &__clickable-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 24px;
    display: grid;
    grid-template-columns: 1% 7% 15.5% 7% 16.2% 7% 16.5% 7% 15% 7% auto;
    &--button {
      cursor: pointer;
    }
    .nettdoc-disabled {
      cursor: not-allowed !important;
    }
  }
}
.nettdoc-exit-modal {
  z-index: 9999;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  &__container {
    opacity: 1;
    background-color: var(--white);
    border-radius: 8px;
    margin: auto;
    max-width: 750px;
    width: calc(100% - 20px);
    margin-top: calc(30%);
    box-sizing: border-box;
    h2 {
      padding: 36px 20px 0 20px;
      font-size: 26px;
      font-weight: 500;
      color: var(--charcoal-grey);
    }
    p {
      margin: unset;
      padding: 0 20px;
      padding-bottom: 10px;
      font-size: 16px;
      font-weight: normal;
    }
    &--bottom {
      border-top: 1px solid #d8d8d8;
      padding: 25px 20px;
      span {
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold;
        color: #e02020;
        cursor: pointer;
      }
      span:nth-of-type(2) {
        float: right;
        color: var(--charcoal-grey);
      }
    }
  }
}
</style>